import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { EInvoiceOperatorsDataGrid } from "src/components/views/erp/sales/masterData/eInvoiceOperators/EInvoiceOperatorsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/eInvoiceOperators")({
	staticData: { title: i18n.t("e_invoice_operators"), legacyViewKey: "eInvoiceOperatorsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <EInvoiceOperatorsDataGrid />;
}
